import type { AuthorCardPropsServer, AuthorCardProps } from "@op/puck-types";
import { LazyComponent } from "../../../utils/LazyComponent";
import { RichTextRenderer } from "../../../renderer/RichTextRenderer";
import { isEmpty } from "../../../renderer/RichTextRenderer/utils";

const AuthorCard = ({ children, ...rest }: AuthorCardPropsServer) => {
  return (
    <LazyComponent<AuthorCardProps> name="AuthorCard" {...rest}>
      {isEmpty(children) ? null : <RichTextRenderer content={children} />}
    </LazyComponent>
  );
};

export default AuthorCard;
